import { render, staticRenderFns } from "./ConsultarEpaf.vue?vue&type=template&id=dce205b6&"
import script from "./ConsultarEpaf.vue?vue&type=script&lang=js&"
export * from "./ConsultarEpaf.vue?vue&type=script&lang=js&"
import style0 from "./ConsultarEpaf.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports